import React, { FC } from "react";
import style from "./style.scss";
import { ThemeBuilderSectionLine } from "./ThemeBuilderSectionLine";
import { WidgetValuePicker, WidgetValuePickerChildrenProps } from "./WidgetValuePicker";
import { Input } from "@xapp/components";

export interface WidgetFontWeightPickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly disabled?: boolean;
    onChange(value: string): void;
}

export const WidgetFontWeightPickerRaw: FC<WidgetValuePickerChildrenProps<string>> = props => {

    return (
        <Input
            className={style.fontWeightValue}
            type="text"
            disabled={props.override || props.disabled}
            value={props.value} onChange={(value: string) => props.onChange(value)} />
    );
};

export const WidgetFontWeightPicker: FC<WidgetFontWeightPickerProps> = props => {
    return (
        <ThemeBuilderSectionLine label={props.label ?? "Font weight"}>
            <WidgetValuePicker<string> key="value" value={props.value} defaultValue={props.defaultValue} children={WidgetFontWeightPickerRaw} disabled={props.disabled} onChange={props.onChange} />
        </ThemeBuilderSectionLine>
    );
};
